import React from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";

const ModalHeader = ({ onClose, title: { id, defaultMessage } }) => {
  return (
    <header className="modal--header">
      <FormattedMessage id={id} defaultMessage={defaultMessage} />
      <a className="modal--close" onClick={onClose}>
        X
      </a>
    </header>
  );
};

ModalHeader.propTypes = {
  title: PropTypes.shape({
    id: PropTypes.string,
    defaultMessage: PropTypes.string,
  }),
  onClose: PropTypes.func,
};

export default ModalHeader;
